'use client';

import { WithTheme } from "@/types/WithTheme";
import { useEffect } from "react";

const fontSrc = {
  // https://fonts.google.com/specimen/Work+Sans
  workSans: "/fonts/WorkSans-VariableFont_wght.ttf",
  workSansItalic: "/fonts/WorkSans-Italic-VariableFont_wght.ttf"
};

export default function FontLoader( props: WithTheme ) {
  const fontFamily = props?.theme?.general?.fontFamily || 'workSans';

  useEffect( () => {
    const fontWeight = '100 900';
    const primaryFont = new FontFace( 'Primary Font', `url(${fontSrc[fontFamily]})`, { weight: fontWeight, display: 'swap' } );
    document.fonts.add( primaryFont );

    const primaryFontItalic = new FontFace( 'Primary Font', `url(${fontSrc[fontFamily]})`, { weight: fontWeight, display: 'swap', style: 'italic' } );
    document.fonts.add( primaryFontItalic );
  }, [fontFamily] );

  return null;
}
